module.exports = __webpack_public_path__ + "img/message.dbd1fa8.svg";